import { IconButton, Typography } from "@mui/material";
import { FaChevronLeft } from "react-icons/fa6";
import { Link } from "react-router-dom";

import { useLearning } from "../hooks/useLearning";

export function Header() {
	const { course } = useLearning();

	if (!course) {
		return;
	}

	return (
		<div className="header">
			<Link to="/training/my-progress">
				<IconButton className="icon-button">
					<FaChevronLeft />
				</IconButton>
			</Link>

			<Link
				to={`/services/${course.courseSlug}`}
				target="_blank"
				className="black-text underline-on-hover-link">
				<Typography className="small-title-text bold">{course.name}</Typography>
			</Link>
		</div>
	);
}
